import { render, staticRenderFns } from "./ProjectTransferDetail.vue?vue&type=template&id=4ec4a1d9"
import script from "./ProjectTransferDetail.vue?vue&type=script&lang=js"
export * from "./ProjectTransferDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports